<app-modal-dialog title="Accept onboarding information" (dismiss)="cancel()">

    <main>
        <app-layout-row>
            <app-layout-column [width]="12">
                <p>This will accept the information provided by the partner and create a distribution.</p>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="12">
                <p>The partner would like to <b>{{direction()==='in' ? 'send' : 'receive'}}</b> documents of type <b>{{documentType().Name}}</b> in the {{documentType().Format.Id ? '' : 'custom'}} format <b>{{documentType().Format.Name}}</b></p>
                <p>Please select the partners and document configurations to be used for this distribution.</p>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="5">
                <p class="partner-label">From Partner</p>
                <ep-partner-selector [selectedPartner]="selectedPartnerIn()" (selectedPartnerChange)="selectedPartnerIn.set($event)">
                </ep-partner-selector>
            </app-layout-column>
            <app-layout-column [width]="2">
            </app-layout-column>
            <app-layout-column [width]="5">
                <p class="partner-label">To Partner</p>
                <ep-partner-selector [selectedPartner]="selectedPartnerOut()" (selectedPartnerChange)="selectedPartnerOut.set($event)">
                </ep-partner-selector>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="5">
            </app-layout-column>
            <app-layout-column [width]="2">
                <div class="arrow-container">
                    <p class="arrow-text">{{transportType()}}</p>
                    <i class="dx-icon-to arrow-icon"></i>
                </div>
            </app-layout-column>
            <app-layout-column [width]="5">
            </app-layout-column>
        </app-layout-row>

        <app-layout-row margin="0rem">
            <app-layout-column [width]="5">
                <app-singleselectbox decorator
                    name="DocumentConfigIn"
                    caption="From Format"
                    [ngModel]="selectedDocConfigIn()"
                    [dataSource]="documentConfigsIn()"
                    displayExpr="DisplayName"
                    (valueChange)="updateSelectedDocumentConfigIn($event)">
                </app-singleselectbox>
            </app-layout-column>
            <app-layout-column [width]="2">
            </app-layout-column>
            <app-layout-column [width]="5">
                <app-singleselectbox decorator
                    name="DocumentConfigOut"
                    caption="To Format"
                    [ngModel]="selectedDocConfigOut()"
                    [dataSource]="documentConfigsOut()"
                    displayExpr="DisplayName"
                    (valueChange)="updateSelectedDocumentConfigOut($event)">
                </app-singleselectbox>
            </app-layout-column>
        </app-layout-row>

        @if ((transportType() === 'SFTP' || transportType() === 'FTP') && direction() === 'in')
        {
            <hr>
            <app-layout-row>
                <app-layout-column [width]="12">
                    <h2>Transport Options</h2>
                    <p>Please select the transport options for this distribution.</p>

                    @if ((transportType() === 'SFTP' || transportType() === 'FTP') && direction() === 'in') {
                        <p class="transport-option-info">Filename example provided by partner: {{filenameExample()}}</p>
                        <app-textbox decorator
                            name="fileMask"
                            caption="File Mask"
                            infoText="Specify the file mask to be used for picking up files from the partner's SFTP folder. Use * as a wildcard. For example, *.xml"
                            [ngModel]="transportOptions()['fileMask'] ?? '*'"
                            (valueChange)="updateTransportOptions('fileMask', $event)">
                        </app-textbox>
                    }
                </app-layout-column>
            </app-layout-row>
        }
    </main>

    <footer>
      <div class="button-container">
        <app-button primary [disabled]="!isValid()" (buttonClick)="acceptAndCreate()">Accept and Create</app-button>
        <app-button secondary (buttonClick)="accept()">Accept - and create manually</app-button>
        <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>

</app-modal-dialog>
